<div class="section instructions p-0">
  <h5 class="instructions-title p-0">{{ task.instructionsTitle }}</h5>
  <p [innerHTML]="task.instructions"></p>
  <div>
    <a
      [href]="task.content.buttonLink"
      [routerLink]="['/appointments/new']"
      *ngIf="!task.content.walkin"
      class="btn btn-lg btn-primary btn-block mb-3"
    >
      {{ task.content.buttonName }}
    </a>
    <a
      [href]="task.content.buttonLink"
      *ngIf="task.content.showNearbyLocations"
      class="btn btn-lg btn-primary btn-block mb-3"
    >
      {{ task.content.buttonName }}
    </a>
    <p *ngIf="task.content.isFluVaccine">{{ task.content.information }}</p>
  </div>
</div>

<div>
  <h5>{{ task.taskOptionsTitle }}</h5>
  <p>{{ task.taskOptionsDescription }}</p>
</div>
